import { ApiError } from "../../api/client";
import type {
  CommandeReservationPayload,
  CommandeStatut,
} from "../../types/domain";

const IDEMPOTENCY_KEY_PATTERN = /^[A-Za-z0-9:_-]{1,200}$/;

export function commandePeutEtreReservee(statut: CommandeStatut): boolean {
  return statut === "APPROUVE" || statut === "A_ACHETER";
}

export function creerTentativeReservation(
  commandeId: string,
  creerIdentifiant: () => string = () => globalThis.crypto.randomUUID(),
): CommandeReservationPayload {
  const idempotencyKey = [
    "RF02",
    commandeId.trim(),
    "RESERVATION",
    creerIdentifiant(),
  ].join(":");

  if (!IDEMPOTENCY_KEY_PATTERN.test(idempotencyKey)) {
    throw new Error("Impossible de générer une clé idempotente valide.");
  }

  return { idempotency_key: idempotencyKey };
}

export function messageErreurReservation(error: unknown): string {
  if (!(error instanceof ApiError)) {
    return "La réservation a échoué de façon inattendue.";
  }

  const detail = error.detail;
  const code =
    typeof detail === "object" && detail !== null && "code" in detail
      ? String(detail.code)
      : null;

  if (code === "IDEMPOTENCY_IN_PROGRESS") {
    return "Cette tentative est déjà en cours. Réessayez dans quelques instants.";
  }

  if (
    code === "IDEMPOTENCY_KEY_CONFLICT" ||
    code === "IDEMPOTENCY_PAYLOAD_CONFLICT"
  ) {
    return "La clé de cette tentative est en conflit. Annulez puis préparez une nouvelle réservation.";
  }

  if (error.category === "network" || error.category === "timeout") {
    return "Résultat incertain. Réessayez : la même clé sera réutilisée sans doubler la réservation.";
  }

  if (error.status === 409) {
    return "La commande ne peut plus être réservée dans son état actuel. Rechargez la fiche.";
  }

  return error.message || "La réservation a échoué.";
}
